import React, { useMemo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { PaginatedEntityTable } from "components/common";
import { fetchPaginatedCollectionCandidates, keyFn } from "collections/hooks/useCollectionCandidates";
import EntityActions from "./EntityActions";
import customColumnRenderers from "./customColumnRenderers";
import BulkActions from "./BulkActions";
export const DEFAULT_LAYOUT = {
  entityTableId: "entities",
  defaultPageSize: 20,
  defaultSort: { attributeId: "name", direction: "asc" },
  defaultDisplayedAttributes: ["name", "type"],
  defaultColumnOrder: ["name", "type"]
};
const EntitiesList = ({ collectionId }) => {
  const { t } = useTranslation("enterprise_collections");
  const [selectedEntities, setSelectedEntities] = useState([]);
  const onBulkSelect = (selected, data) => {
    setSelectedEntities(data.filter((entity) => selected.includes(entity.id)));
  };
  const bulkSelection = useMemo(
    () => ({
      onChangeSelection: onBulkSelect,
      actions: /* @__PURE__ */ React.createElement(BulkActions, { selectedEntities, collectionId })
    }),
    [collectionId, selectedEntities]
  );
  const entitiesActions = useCallback(
    ({ id, type }) => /* @__PURE__ */ React.createElement(EntityActions, { collectionId, id, type }),
    [collectionId]
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("human_names.entities"),
      entityActions: entitiesActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: (searchParams) => fetchPaginatedCollectionCandidates(collectionId, searchParams),
      keyFn: (searchParams) => keyFn(collectionId, searchParams),
      columnRenderers: customColumnRenderers,
      entityAttributesAreCamelCase: false,
      searchPlaceholder: t("lists.search_entity"),
      bulkSelection
    }
  );
};
export default EntitiesList;
